$('.news__slider').each(function(){
    $(this).attr('data-offset', `${$(this).offset().left}`);
})